import React from 'react';
import { Link } from 'react-router-dom';
import PortfolioShell from './PortfolioShell';
import './PortfolioPages.css';

export default function CreditsPage() {
  return (
    <PortfolioShell>
      <article className="portfolio-container pf-credits" style={{ maxWidth: '760px', paddingTop: '4rem', paddingBottom: '5rem' }}>
        <p className="pf-eyebrow">About this site</p>
        <h1>Credits</h1>
        <p>Original artwork was produced with Midjourney and edited in Adobe Photoshop.</p>
        <p>The original site's base CSS layout was adapted from <a href="https://www.freecodecamp.org/news/how-to-create-a-portfolio-website-using-html-css-javascript-and-bootstrap/">Sampurna Chapagain's Bootstrap portfolio tutorial</a>. The site has since been extended and redesigned.</p>
        <p>Project descriptions, working notes, and other original content © Robert Miller, 2023–2026.</p>
        <Link className="pf-text-link" to="/">Return to the portfolio <span aria-hidden="true">→</span></Link>
      </article>
    </PortfolioShell>
  );
}
